

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ScheduleHParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface ScheduleH {

  fromDate: any;
  toDate: string;
  medicineType: string;
  physicianId: any;
   
  skip:Number,
  take:Number,
    tenantId?: string;
    branchId?: string;
    
  
    parameters?: ScheduleHParameter[];
    links?: any;
}

export abstract class ScheduleHData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<ScheduleH[]>;
  abstract searchList(url: string,data: any): Observable<any>;
  abstract update(url: string,data: ScheduleH): Observable<any>;
  abstract delete(url: string): Observable<any>;

  abstract searchForMultiBranch(url: string,data:any): Observable<any>;
}
